var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.copy(_vm.value)}}},[_vm._v(_vm._s(_vm.value)),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-content-copy")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }